import { TranslateFunction } from "../../../../hooks/useTranslate";

export const mainTableColumnTitles = (t: TranslateFunction): string[] => [
    t('table.columnsTitles.substance'),
    t('table.columnsTitles.substanceDescription'),
    t('table.columnsTitles.workPosition'),
    t('table.columnsTitles.sector'),
    // t('table.columnsTitles.preventiveMeasures'),
    // t('table.columnsTitles.protectionElements'),
    // t('table.columnsTitles.environmentalStudies'),
    t('table.columnsTitles.informationState'),
    '',
    // t('table.columnsTitles.edit')
];
